import React from 'react';

export default function Header() {
  return (
    <header className="h-14 bg-[#1890ff] flex items-center justify-between px-6 text-white shadow-sm z-10 shrink-0">
      <div className="flex items-center space-x-8">
        <div className="flex items-center space-x-2 font-bold text-xl tracking-wide">
          <div className="w-5 h-5 bg-white rounded-sm opacity-90"></div>
          <span>SUDY 综合测评系统</span>
        </div>
        <div className="text-sm cursor-pointer hover:text-blue-100 transition">首页</div>
      </div>
      <div className="text-sm flex items-center space-x-2 cursor-pointer">
        <span>白磊 | 管理员/辅导员</span>
      </div>
    </header>
  );
}
